import barba from '@barba/core';

class Menu {
  constructor(root) {
    this.root = root;
    this.isOpen = false;

    this.bind();

    barba.hooks.beforeEnter((data) => {
      // Close the menu
      this.close();

      // Unbind
      this.unbind();

      // Insert new menu
      const nextDom = document.createElement('div');
      nextDom.innerHTML = data.next.html;

      const nextMenu = nextDom.querySelector('[data-menu]');

      this.root.innerHTML = nextMenu.innerHTML;

      // Bind
      this.bind();
    });
  }

  bind() {
    this.burger = this.root.querySelector('[data-menu--burger]');
    this.content = this.root.querySelector('[data-menu--content]');

    this.onClick = this.onClick.bind(this);

    this.burger.addEventListener('click', this.onClick);
  }

  unbind() {
    this.burger.removeEventListener('click', this.onClick);
  }

  onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this[this.isOpen ? 'close' : 'open']();
  }

  open() {
    this.root.classList.add('menu-is-open');
    this.isOpen = true;
  }

  close() {
    this.root.classList.remove('menu-is-open');
    this.isOpen = false;
  }
}

export default {
  when() {
    return document.querySelectorAll('[data-menu]').length > 0
  },

  mounted() {
    this.instances = [];
    document.querySelectorAll('[data-menu]').forEach(menu => {
      const instance = new Menu(menu);
      this.instances.push(instance);
    })
  },
}
